import { createContext } from 'react';
import { SourcePages } from 'lib/EventSchema';

interface SrpEventContextInfo {
  sourcePage: SourcePages;
  sourcePageCategory?: string;
}

export default createContext<SrpEventContextInfo>({
  sourcePage: '' as SourcePages,
});
